import { auth, db } from '../config/firebase';
import { doc, getDoc, collection, query, where, orderBy, limit, getDocs } from 'firebase/firestore';
import { checkStoryStatus } from '../services/storyGenerationService';

/**
 * A utility function to test the story status checking 
 * with detailed console logs
 * @param {string} webhookId - The ID of the webhook/story progress to check
 */
export async function testStoryStatusCheck(webhookId) {
  console.log('🧪 TESTING STORY STATUS CHECK');
  console.log('--------------------------');
  
  try {
    // First try to directly access the document to see its raw state
    console.log('👀 Directly checking document state...');
    const webhookRef = doc(db, 'storyProgress', webhookId);
    const webhook = await getDoc(webhookRef);
    
    if (!webhook.exists()) {
      console.error('❌ Document does not exist!');
      return;
    }
    
    const data = webhook.data();
    console.log('📋 Raw document data:', {
      id: webhookId,
      status: data.status,
      hasResult: !!data.result,
      hasContent: !!data.content,
      userId: data.userId ? 'present' : 'missing',
      createdAt: data.createdAt?.toDate?.() || data.createdAt,
      updatedAt: data.updatedAt?.toDate?.() || data.updatedAt
    });
    
    // Now test the actual service function
    console.log('🔄 Now testing the service function...');
    const result = await checkStoryStatus(webhookId);
    console.log('✅ Service function result:', result);
    
    return result;
  } catch (error) {
    console.error('💥 Test failed with error:', error);
    return { error: error.message };
  }
}

// Export a function to test the most recently "stuck" document
export async function testMostRecentStoryProgress() {
  try {
    console.log('🔍 Looking for the most recent storyProgress document...');
    
    // Check if we're authenticated
    if (!auth.currentUser) {
      console.error('❌ No authenticated user found. Please log in first.');
      return;
    }
    
    // Create a query using the Firebase v9 modular SDK
    const storyProgressRef = collection(db, 'storyProgress');
    const q = query(
      storyProgressRef,
      where('userId', '==', auth.currentUser.uid),
      orderBy('createdAt', 'desc'),
      limit(1)
    );
    
    const querySnapshot = await getDocs(q);
    
    if (querySnapshot.empty) {
      console.error('❌ No story progress documents found for current user.');
      return;
    }
    
    const doc = querySnapshot.docs[0];
    console.log('📑 Found document:', doc.id);
    
    return testStoryStatusCheck(doc.id);
  } catch (error) {
    console.error('💥 Error finding recent story progress:', error);
    return { error: error.message };
  }
}
